import { useConfigureBreadcrumbs } from 'record-it-components/hooks/useConfigureBreadcrumbs/useConfigureBreadcrumbs';
import { BreadcrumbsBuilder } from '../../classes/misc/BreadcrumbsBuilder/BreadcrumbsBuilder';

export function useConfigureBreadcrumbsWithBuilder(
  prepareBuilder: (buidler: BreadcrumbsBuilder) => void
): void {
  const builder = new BreadcrumbsBuilder();
  prepareBuilder(builder);
  useConfigureBreadcrumbs(builder.disable().build());
}
